import React, { useEffect, useState } from 'react'
import preloadimg from "../../assets/img/preloader1.gif";
import PBIVisuals from '../customVisuals/CustomVisuals';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import { useCustomVisuals } from '../../hooks/useCustomVisuals';


const skeletonStyle = {
  backgroundColor: '#f0f0f0', // Set the background color for the skeleton
  position: 'relative',
  overflow: 'hidden',
  marginTop:"10px",
  width:"100%",
  border: "2px solid #eee",

};



const LandingKPIReport = (props) => {

  const { fetchCustomVisuals } = useCustomVisuals();
  const [reportVisuals, setReportVisuals] = useState([])
  const [Loading,setLoading] = useState(true)

  useEffect(() => {
    setLoading(true);
    fetchCustomVisuals(props.groupId)
      .then((data) => {
        setReportVisuals(data);
        setLoading(false);
      })
      .catch(() => {
        setReportVisuals([]);
        setLoading(false);
      });
  }, [fetchCustomVisuals, props.groupId]);


  const defaultRL = props.defaultRL
  const rlTypeData = props.rlType



  return (
    <>
      {Loading && (
        <div style={{height:"420px"}} className="customVisuals_flex">
          <div style={skeletonStyle}>
            <div
              style={{
                position: "absolute",
                background: "white",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 1,
              }}
              className="pageLoading"
            >
              <img width={200} src={preloadimg} alt="Loading" />
            </div>
          </div>

          <div style={skeletonStyle}>
            <div
              style={{
                position: "absolute",
                background: "white",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 1,
              }}
              className="pageLoading"
            >
              <img width={200} src={preloadimg} alt="Loading" />
            </div>
          </div>

        </div>
      )}

      {!Loading && reportVisuals.length === 0 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            padding: "3rem 1rem",
            textAlign: "center",
            color: "#9ca3af",
            fontSize: "14px",
            border: "1px dashed #e5e7eb",
            borderRadius: "10px",
            marginTop: "10px",
            background: "#fafafa",
          }}
        >
          <InsertChartOutlinedIcon style={{ fontSize: 48, color: "#d1d5db" }} />
          <span>Visuals is not selected, please select the visuals from the user administration page.</span>
          <a
            href="/settings/visuals"
            style={{
              fontSize: "12px",
              fontWeight: 600,
              color: "var(--app-icon-color, #a70e13)",
              textDecoration: "none",
            }}
          >
            Customize Visuals →
          </a>
        </div>
      )}

      {!Loading && reportVisuals.length > 0 && (
        <div className="visuals_container">
          {reportVisuals.map((ivisuals, Index) => {
            return (
              <div
                key={Index}
                style={{
                  // boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
                  height: "420px",
                  padding: "1rem",
                  borderRadius: "6px",
                  border: "2px solid #eee",
                  width: "99%",
                  paddingBottom: "5rem",
                }}
              >
                <PBIVisuals
                  report_id={ivisuals.report_id}
                  report_name={ivisuals.report_name}
                  visuals_id={ivisuals.visualName}
                  title={ivisuals.name}
                  defaultRL={defaultRL}
                  rlTypeData={rlTypeData}
                  filter1 = {ivisuals.filter1 === "null" ? "" :ivisuals.filter1}
                  filter2 = {ivisuals.filter2 === "null" ? "" :ivisuals.filter2}
                  filter3 = {ivisuals.filter3 === "null" ? "" :ivisuals.filter3}
                  filter4 = {ivisuals.filter4 === "null" ? "" :ivisuals.filter4}
                  filter5 = {ivisuals.filter5 === "null" ? "" :ivisuals.filter5}


                />
              </div>
            );
          })}
      
        </div>
      )}
    </>
  );
}

export default LandingKPIReport
